import { CHANGE_PLAN } from './useChangePlan';

export const changePlanMock = [
  {
    request: {
      query: CHANGE_PLAN,
      variables: {
        accountId: '1',
        inputData: {
          plan_id: '1',
          downgradeReason: null,
        },
      },
    },
    result: {
      data: {
        id: '1',
        currentPlan: {
          id: '1',
        },
      },
    },
  },
];
